<template>
  <v-flex
    pt-3
    xs12
  >
    <h5 style="font-weight: medium; color: red;">
      A cancellation fee of {{ (bookingForm.booking.booking_cancellation_fee.amount / 100).toFixed(2) }} was charged for this booking
    </h5>
    <v-layout v-if="paymentIntent">
      <v-flex class="py-0 px-0">
        <v-list
          class="py-0 px-0"
          dense
        >
          <v-list-item
            class="py-0 px-0 list-item-height"
            dense
          >
            <v-list-item-content>
              <v-list-item-subtitle>
                <span class="text--primary">{{ formatDate(paymentIntent.created) }}</span> <v-chip
                  x-small
                  color="green lighten-4"
                >
                  {{ paymentIntent.status }}
                </v-chip>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            class="py-0 px-0 list-item-height"
            dense
          >
            <v-list-item-content>
              <v-list-item-subtitle>
                <span class="text--primary">Paid By</span> Stripe
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            class="py-0 px-0 list-item-height"
            dense
          >
            <v-list-item-content>
              <v-list-item-subtitle>
                <span class="text--primary">Transaction ID</span> {{ paymentIntent.id }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            class="py-0 px-0 list-item-height"
            dense
          >
            <v-list-item-content>
              <v-list-item-subtitle>
                <span class="text--primary">Statement Description</span> {{ paymentIntent.statement_descriptor }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            class="py-0 px-0 list-item-height"
            dense
          >
            <v-list-item-content>
              <v-list-item-subtitle>
                <span class="text--primary">Amount</span> £{{ formatAmount(paymentIntent.amount) }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            class="py-0 px-0 list-item-height"
            dense
          >
            <v-list-item-content>
              <v-list-item-subtitle>
                <span class="text--primary">Fee</span> £{{ formatAmount(totalFee) }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            class="py-0 px-0 list-item-height"
            dense
          >
            <v-list-item-content>
              <v-list-item-subtitle>
                <span class="text--primary">Net</span> £{{ formatAmount(netAmount) }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-flex>
    </v-layout>

    <p
      v-if="bookingForm.booking.booking_cancellation_fee.authorizer != null"
      style="font-weight: medium"
    >
      Authorized by {{ bookingForm.booking.booking_cancellation_fee.authorizer }}
    </p>
    <p
      v-else
      style="font-weight: medium"
    >
      Authorized by system policy
    </p>
    <v-col
      wrap
      align-start
    >
      <v-btn
        small
        class="text-none"
        target="_blank"
        :href="cardPaymentLink"
      >
        View Cancellation Fee on Stripe
      </v-btn>
      <p>
        {{ (bookingForm.booking.booking_cancellation_fee.refunded ? "Cancellation fee has been fully or partially refunded. " : "") + ("Amount available for refund " + amountAvailableForRefund) }}
      </p>
      
      <v-flex pt-2>
        <StripeCancellationFeeRefund :booking-form="bookingForm" />
      </v-flex>
    </v-col>
  </v-flex>
</template>

<script>
import StripeCancellationFeeRefund from "@/components/booking/StripeCancellationFeeRefund.vue";

import axios from "axios";
import moment from 'moment'

axios.defaults.withCredentials = true;

export default {
  name: "StripeCancellationFeeV2",
  components: {
    StripeCancellationFeeRefund
  },
  props: {
    bookingForm: Object,
  },
  data: function () {
    return {
      dialog: false,
      loading: false,
      transactions: [],
      amountAvailableForRefund: "£--.--"
    };
  },
  computed: {
    totalFee () {
      let fee = 0;
      this.paymentIntent.charges.data.forEach(charge => {
        if (charge.balance_transaction) {
          fee += charge.balance_transaction.fee
        }
      })

      return fee
    },
    netAmount () {
      return (this.paymentIntent.amount - this.totalFee)
    },
    paymentIntent () {
      if (this.bookingForm.booking.cancellation_fee_payment_intent) {
        return JSON.parse(this.bookingForm.booking.cancellation_fee_payment_intent)
      }
      return null;
    },
    hasOutboundAndReturn: function() {
      return (this.bookingForm.booking.cart != null && this.bookingForm.booking.cart.outboundBookingId != null && this.bookingForm.booking.cart.returnBookingId != null);
    },
    outboundAndReturnString: function() {
      if (this.bookingForm.booking.cart != null && this.bookingForm.booking.cart.outboundBookingId != null && this.bookingForm.booking.cart.returnBookingId != null) {
        return "This stripe payment is associated with two bookings.<br><b>Outbound:</b> " + this.bookingForm.booking.cart.outboundBookingId + "<br><b>Return:</b> " + this.bookingForm.booking.cart.returnBookingId;
      } 

      return "";
    },
    cardPaymentLink: function () {
      return (
        "https://dashboard.stripe.com/search?query=" +
        (this.bookingForm.booking.booking_cancellation_fee.paymentIntentId)
      );
    },
  },
  mounted: function () {
    console.log("StripeTransaction");

    this.getAmountAvailableToRefund();
  },
  methods: {
    formatDate(date) {
      return moment.unix(date).format("DD-MM-YYYY HH:MM")
    },
    formatAmount(amount) {
      return (amount / 100).toFixed(2)
    },
    getAmountAvailableToRefund: async function () {
      this.loading = true;
      try {
        var url = `${this.$store.state.apiUrl}/booking/getRefundableAmountForPaymentIntent?token=${this.bookingForm.booking.booking_cancellation_fee.paymentIntentId}`;

        let response = await axios.get(url, {
          params: {},
        });

       this.amountAvailableForRefund = "£" + (response.data.amount / 100).toFixed(2)

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log("Failed to get customer " + error);
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.v-timeline-item {
  padding-bottom: 8px !important;
}

.v-timeline {
  padding-top: 8px !important;
}

.v-timeline-item {
  padding-bottom: 8px !important;
}


.list-item-height {
  min-height: 20px !important;
  line-height: 20px;
  font-size: 11px !important;
  font-weight: 300;
}

.v-list--dense .v-list-item .v-list-item__content, .v-list-item--dense .v-list-item__content {
  padding: 0px;
  font-size: 11px;
}

.v-list--dense .v-list-item .v-list-item__subtitle {
  font-size: 11px !important;
  font-weight: 450;
}

</style>

   
